/**
 * Hands `url` to the browser's own downloader, which streams it to disk with its
 * progress bar. Only for URLs that answer with `Content-Disposition: attachment`
 * (a presigned dataset original); the page stays where it is. A URL that answers
 * inline would replace the app in this tab.
 *
 * An anchor rather than `window.open`: a window opened after an `await` can be
 * refused by a popup blocker (Safari is the strictest), and an anchor click opens none.
 */
export function startBrowserDownload(url: string): void {
  const a = document.createElement("a");
  a.href = url;
  a.rel = "noreferrer";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/** Saves a file the app already holds: a generated `.qml`, or a fetched CM-table GeoJSON. */
export function saveBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
